import React from 'react';
import Datas from '../Datas';
import Cakes from './Cakes';
import '../shopping.css'

const Shopping = ({handleClick}) => {
  return (
    <section className="products">
        {
        Datas.map((item) => (
            <Cakes item={item} key={item.id} handleClick={handleClick} />
        ))
    }
    </section>
    
  )
}
export default Shopping;
